<template>
  <div>
    <Home />
    <!-- <About /> -->
  </div>
</template>

<script>
import Home from "../../components/Home.vue";
// import About from "../../components/About.vue";

export default {
  name: "app",
  components: {
    Home,
    // About,
  },
};
</script>

<style>
body {
  background: linear-gradient(180deg, rgba(0,0,0,1) 43%, rgba(102,102,102,1) 100%) !important;
}

@media screen and (max-width: 768px) {

  body {
    background: #000 !important;
  }

  .hero {
    background: linear-gradient(0deg, rgba(0,0,0,1) 3%, rgba(255,226,0,1) 12%, rgba(255,106,0,1) 100%);
  }

  #home .hero-body {
    padding-bottom: 50px !important;
    font-size: 14px !important;
  }

  .hero .lucky-title {
    font-size: 30px !important;
    line-height: 2rem !important;
  }

  .hero-body p {
    text-align: center;
  }

  .site-section h1 {
    display: none;
  }

  #about .columns {
    margin-top: 0 !important;
  }

}
</style>